@if (customTextTrustedHTML != undefined) {
  @if (embeddInCard == undefined || embeddInCard == false) {
    <div [innerHTML]="customTextTrustedHTML"></div>
  }
  @if (embeddInCard != undefined && embeddInCard == true) {
    <div class="card">
      <div class="card-body">
        <div [innerHTML]="customTextTrustedHTML"></div>
      </div>
    </div>
  }
}
